package pl.nickers.match3.ecs

import kotlin.random.Random

internal fun restoreBrokenIceCube(
    entityId: Int,
    jellyTypeMapper: ComponentMapper<JellyTypeComponent>,
    bodyImageMapper: ComponentMapper<BodyImageComponent>,
    jellyFaceMapper: ComponentMapper<JellyFaceComponent>,
    draggableMapper: ComponentMapper<DraggableComponent>,
    pieceIdMapper: ComponentMapper<PieceIdComponent>,
    random: Random,
    catalog: EntityCatalog,
) {
    val selection = catalog.selectRandom(random)
    jellyTypeMapper.set(entityId, JellyTypeComponent(type = selection.typeId))
    bodyImageMapper.set(entityId, BodyImageComponent(image = selection.bodyImage))
    jellyFaceMapper.set(entityId, JellyFaceComponent(image = selection.faceImage))
    draggableMapper.set(entityId, DraggableComponent())
    pieceIdMapper.set(entityId, PieceIdComponent(selection.pieceId))
}

fun stampMatchNeighbours(world: World, matches: Set<Int>, width: Int, height: Int) {
    val posMapper = world.mapper<GridPositionComponent>()
    val matchNeighbourMapper = world.mapper<MatchNeighbourComponent>()
    val aspect = Aspect.all(GridPositionComponent::class)
    for (eid in matches) {
        val pos = posMapper[eid] ?: continue
        val r = pos.row
        val c = pos.col
        for ((dr, dc) in listOf(1 to 0, -1 to 0, 0 to 1, 0 to -1)) {
            val nr = r + dr
            val nc = c + dc
            if (nr in 0 until height && nc in 0 until width && (nr to nc) != (r to c)) {
                val neighbour = world.getEntitiesForAspect(aspect).firstOrNull {
                    posMapper[it]!!.row == nr && posMapper[it]!!.col == nc
                } ?: continue
                if (neighbour !in matches) matchNeighbourMapper.set(neighbour, MatchNeighbourComponent())
            }
        }
    }
}
